import { ErrorMessage, Field, Form, Formik } from "formik";
import React from "react";
import "react-phone-number-input/style.css";
import { useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";
import CustomToast from "../Components/CustomToast/CustomToast";
import SignupTestimonials from "../PageComponents/SignupTestimonials";
import { loginToggle } from "../Redux/Actions/dataAction";
import { login } from "../Services/api";
import logo from "./../Images/vistaplots-logo.png";

function Login() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const defaultDetails = {
    email: "",
    password: "",
  };

  const schema = Yup.object().shape({
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required"),
    password: Yup.string().required("Password is required"),
  });

  const doLogin = async (values) => {
    try {
      const loginResp = await login(values);
      dispatch(loginToggle(loginResp.data));
      navigate("/properties");
    } catch (error) {
      toast(<CustomToast type="error" message={error} />, {
        autoClose: 3000,
      });
    }
  };

  return (
    <>
      {/* contact form starts*/}
      <div className="contact">
        <div className="signup w-100">
          <div className="row">
            <div className="col-md-6 order-2 order-md-1">
              <div className="light-pink mt-auto">
                <div className="success-txt text-center login-upper-text">
                  <h4>
                    India's tech-enabled <Link to>commercial property</Link>{" "}
                    listing platform
                  </h4>
                  <p>
                    Our users love our features, customer service, and
                    easy-to-use dashboard.
                  </p>
                </div>
                <SignupTestimonials />
              </div>
            </div>

            <div className="col-md-6 order-1 order-md-2">
              <div className="contact-area px-5 py-3 signup-form h-100">
                <div className="signup-logo mb-30per">
                <Link to="/">
    <img src={logo} width={65} alt=""/>
    </Link>
                </div>
                <div className="d-flex flex-column justify-content-center">
                  <div className="row">
                    <div className="col-lg-12 mb-5 mb-lg-0">
                      <Formik
                        // enableReinitialize={true}
                        initialValues={defaultDetails}
                        validationSchema={schema}
                        onSubmit={(values) => {
                          doLogin(values);
                        }}
                      >
                        <Form>
                          <div className="contact-form row">
                            <div className="mb-3 col-lg-12">
                              <label className="form-label">Email</label>
                              <Field
                                name="email"
                                type="email"
                                className="form-control"
                              />
                              <ErrorMessage
                                name="email"
                                render={(msg) => (
                                  <div className="text-danger">{msg}</div>
                                )}
                              />
                            </div>

                            <div className="mb-3 col-lg-12">
                              <label className="form-label">Password</label>
                              <div className="inputForPassword">
                                <Field
                                  name="password"
                                  type="password"
                                  className="form-control"
                                />
                              </div>
                              <ErrorMessage
                                name="password"
                                render={(msg) => (
                                  <div className="text-danger">{msg}</div>
                                )}
                              />
                            </div>
                            <div className="signup-btn text-end mb-4">
                              <p className="text-end">
                                {" "}
                                <Link to="/forgot-password">
                                  Forgot Password?
                                </Link>
                              </p>
                            </div>
                            <div className="send-button signup-btn">
                              <button>Log In</button>
                              <p>
                                New to vistaplots?{" "}
                                <Link to="/signup">Sign Up</Link>
                              </p>
                            </div>
                          </div>
                        </Form>
                      </Formik>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* contact form ends */}
    </>
  );
}

export default Login;
